import axios from 'axios';
import { call, put, takeEvery, delay } from 'redux-saga/effects';
import * as A from '../actions/stationUploadFileAction';
import { API_PATH }  from '../config';
import { authHeader } from '../helper/authHeader';

const STATIONUPLOADFILE_API = `${API_PATH}/station/file_upload`;


const getStationUploadFileApi = (station) => {
   let params = [];
   let url = `${STATIONUPLOADFILE_API}`;
   if (station) params.push(`id=${station}`);
   if (params.length > 0)
      url = url + '?' + params.join('&');
   return axios.get(url, 
      {
         headers: {...authHeader()},
         timeout: 5000
      }).then( (response) => response.data);
}

function* getStationUploadFile(action) {

   let fetch = undefined;
   try {
      fetch = yield call(getStationUploadFileApi, action.station);
      if (fetch) {
         if (fetch.success) {
            yield put(A.stationUploadFileListSuccess({result: fetch.result}));
         } else {
            yield put(A.stationUploadFileListFailure('系統處理發生問題, 稍後再試 !'));
         }
      } else {
         yield put(A.stationUploadFileListFailure('資料錯誤 !'));
      }

   } catch (error) {
      yield put(A.stationUploadFileListFailure(`資料錯誤, ${error.message}`));
   }
}

const addStationUploadFileApi = (data) => {
   let url = `${STATIONUPLOADFILE_API}`;
   return axios.post(url, data,
      {
         headers: {...authHeader()},
         timeout: 5000
      }).then( (response) => response.data);
}

function* addStationUploadFile(action) {

   let fetch = undefined;
   try {

      fetch = yield call(addStationUploadFileApi, action.data);
      if (fetch) {

         if (fetch.success) {
            yield put(A.stationUploadFileAddSuccess({result: fetch.result}));
         } else {
            yield put(A.stationUploadFileAddFailure('系統處理發生問題, 稍後再試 !'));
         }
      } else {
         yield put(A.stationUploadFileAddFailure('資料錯誤 !'));
      }

   } catch (error) {
      yield put(A.stationUploadFileAddFailure(`資料錯誤, ${error.message}`));
   }
}

const deleteStationUploadFileApi = (station, id) => {
   let url = `${STATIONUPLOADFILE_API}?id=${id}&station_id=${station}`;
   return axios.delete(url,
      {
         headers: {...authHeader()},
         timeout: 5000
      }).then( (response) => response.data);
}

function* deleteStationUploadFile(action) {

   let fetch = undefined;
   try {
      console.log(action)
      fetch = yield call(deleteStationUploadFileApi, action.station, action.id);
      if (fetch) {

         if (fetch.success) {
            yield put(A.stationUploadFileDeleteSuccess({result: fetch.result}));
         } else {
            yield put(A.stationUploadFileDeleteFailure('系統處理發生問題, 稍後再試 !'));
         }
      } else {
         yield put(A.stationUploadFileDeleteFailure('資料錯誤 !'));
      }

   } catch (error) {
      yield put(A.stationUploadFileDeleteFailure(`資料錯誤, ${error.message}`));
   }
}

export default function* watchStationUploadFileAction() {
   yield takeEvery(A.STATIONUPLOADFILE_LIST_REQUEST, getStationUploadFile);
   yield takeEvery(A.STATIONUPLOADFILE_ADD_REQUEST, addStationUploadFile);
   yield takeEvery(A.STATIONUPLOADFILE_DELETE_REQUEST, deleteStationUploadFile);
}